"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isMediaVariableToken = exports.mediaVariable = exports.Media = void 0;
var Models_1 = require("ContentTokens/Models");
var Image_1 = require("./Image");
var Video_1 = require("./Video");
var Media;
(function (Media) {
    Media["Image"] = "image";
    Media["Video"] = "video";
    Media["GoogleMaps"] = "googleMaps";
    Media["Iframe"] = "iframe";
})(Media = exports.Media || (exports.Media = {}));
exports.mediaVariable = {
    createToken: function (media, name, label, options) {
        if (options === void 0) { options = {}; }
        var token = {
            type: "block",
            subType: Models_1.BlockType.MediaVariable,
            media: media,
            name: name,
            label: label,
        };
        var width = options.width, alignment = options.alignment, height = options.height;
        if (width) {
            token.width = width;
        }
        if (height) {
            token.height = height;
        }
        if (alignment) {
            token.alignment = alignment;
        }
        return token;
    },
    createSlateJson: function (media, name, label, options) {
        if (options === void 0) { options = {}; }
        if (media === Media.Image) {
            return Image_1.image.createSlateJson("", __assign({ variable: { name: name, label: label } }, options));
        }
        else if (media === Media.Video) {
            return Video_1.video.createSlateJson(null, null, options.width, { variable: { name: name, label: label } });
        }
        throw new Error("Got unsupported or unimplemented media type for media variable slate json: ".concat(media));
    },
};
var isMediaVariableToken = function (token) {
    return token.type === "block" && token.subType === Models_1.BlockType.MediaVariable;
};
exports.isMediaVariableToken = isMediaVariableToken;
